'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import CtaLink from 'components/essentials/Cta/CtaLink';
const CategoryCollectionBackLink = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="w-[70%] mb-4 p-2 bg-brand-lightest"><CtaLink to="/collections" styling="link" size="sm" hasArrow={false} color="brand" spacing="sm" className="flex">{"<  All collections"}</CtaLink></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default CategoryCollectionBackLink;